import React from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import moment from "jalali-moment";
import { addCommas } from "../../utils";
import { Link } from "react-router-dom";
import styles from "../../screens/getOrders/OrdersPanel.module.css";

function statusBadgeClass(statusFa) {
  if (!statusFa) return styles.badge;
  if (String(statusFa).includes("ارسال")) return `${styles.badge} ${styles.badgeOk}`;
  if (String(statusFa).includes("آماده")) return `${styles.badge} ${styles.badgeInfo}`;
  if (String(statusFa).includes("پرداخت")) return `${styles.badge} ${styles.badgeWarn}`;
  return `${styles.badge} ${styles.badgeWarn}`;
}

function payBadgeClass(paymentFa) {
  if (paymentFa === "پرداخت شده") return `${styles.badge} ${styles.badgeOk}`;
  if (paymentFa === "در حال بررسی") return `${styles.badge} ${styles.badgeWarn}`;
  if (paymentFa === "پرداخت نشده") return `${styles.badge} ${styles.badgeBad}`;
  return styles.badge;
}

/** Display-only; same calendar/digits/layout as GetQuotes (local copy). */
function formatFaDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("fa-IR");
}

/**
 * Orders table — same filters/pagination/fields/actions as production MyListOrder.
 * Visual shell aligned with GetQuotes. Isolated workspace copy.
 */
const MyListOrder = ({
  data,
  pages,
  setPage,
  page,
  totalDocs,
  set_search_text,
  search_text,
  GetPayments_function,
  set_status,
  _status,
  set_start_date,
  set_end_date,
  selectedDayRange,
  setSelectedDayRange,
}) => {
  const runSearch = () => {
    setPage(1);
    GetPayments_function().then(() => null);
  };

  return (
    <>
      <div className={styles.filters}>
        <div className={styles.field}>
          <label htmlFor="order-search">جستجو (شماره فاکتور)</label>
          <input
            id="order-search"
            type="search"
            value={search_text}
            onChange={(e) => set_search_text(e.target.value)}
            placeholder="شماره فاکتور…"
          />
        </div>
        <div className={styles.field}>
          <label>بازه تاریخ</label>
          <DatePicker
            value={selectedDayRange}
            onChange={(e) => {
              const from = e.from;
              const to = e.to;
              if (from)
                set_start_date(
                  moment(
                    `${from.year}/${
                      String(from.month).length === 1 ? "0" + from.month : from.month
                    }/${String(from.day).length === 1 ? "0" + from.day : from.day}`,
                    "jYYYY/jMM/jDD HH:mm:ss"
                  ).toISOString()
                );
              if (to)
                set_end_date(
                  moment(
                    `${to.year}/${
                      String(to.month).length === 1 ? "0" + to.month : to.month
                    }/${String(to.day).length === 1 ? "0" + to.day : to.day}`,
                    "jYYYY/jMM/jDD HH:mm:ss"
                  ).toISOString()
                );
              setSelectedDayRange(e);
            }}
            inputPlaceholder="انتخاب نمایید"
            shouldHighlightWeekends
            locale="fa"
          />
        </div>
        <div className={styles.field}>
          <label htmlFor="order-pay-status">وضعیت پرداخت</label>
          <select
            id="order-pay-status"
            className="custom-select"
            value={_status == null ? "" : String(_status)}
            onChange={(e) => {
              const v = e.target.value;
              set_status(v === "" ? null : v);
            }}
          >
            <option value="">همه</option>
            <option value="true">موفق</option>
            <option value="false">ناموفق</option>
          </select>
        </div>
        <div className={styles.field}>
          <label>&nbsp;</label>
          <button type="button" className={styles.btnPrimary} onClick={runSearch}>
            جستجو
          </button>
        </div>
      </div>

      <div className={styles.tableCard}>
        <div style={{ padding: "12px 14px", fontWeight: 700, color: "#1f355e" }}>
          تعداد سفارشات: {addCommas(totalDocs)}
        </div>

        {!data || data.length === 0 ? (
          <div className={styles.empty}>موردی یافت نشد.</div>
        ) : (
          <>
            <div className={styles.tableWrap}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>شماره فاکتور</th>
                    <th>نام کاربر</th>
                    <th>مبلغ</th>
                    <th>وضعیت</th>
                    <th>وضعیت پرداخت</th>
                    <th>تاریخ ایجاد</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => (
                    <tr key={String(item._id)}>
                      <td className={styles.refCell}>{item.order_code}</td>
                      <td>{item.user_id?.name || "—"}</td>
                      <td>{addCommas(item.price)} تومان</td>
                      <td>
                        <span className={statusBadgeClass(item.status)}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <span className={payBadgeClass(item.payment_status)}>
                          {item.payment_status || "—"}
                        </span>
                      </td>
                      <td>
                        {formatFaDateTime(item.creation_date)}
                      </td>
                      <td>
                        <Link to={`/dashboard/orderDetails/${item._id}`}>
                          <button type="button" className={styles.btnDetail}>
                            جزئیات
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className={styles.mobileCards}>
              {data.map((item) => (
                <div className={styles.mobileCard} key={`m-${item._id}`}>
                  <div className={styles.refCell}>{item.order_code}</div>
                  <div className={styles.mobileRow}>
                    <span>{item.user_id?.name || "—"}</span>
                    <span>{addCommas(item.price)} تومان</span>
                  </div>
                  <div className={styles.mobileRow}>
                    <span className={statusBadgeClass(item.status)}>
                      {item.status}
                    </span>
                    <span className={payBadgeClass(item.payment_status)}>
                      {item.payment_status || "—"}
                    </span>
                  </div>
                  <div className={styles.mobileRow}>
                    <span>
                      {formatFaDateTime(item.creation_date)}
                    </span>
                    <Link to={`/dashboard/orderDetails/${item._id}`}>
                      <button type="button" className={styles.btnDetail}>
                        جزئیات
                      </button>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        <div className={styles.footer}>
          <div className={styles.pager}>
            {page !== 1 ? (
              <button
                type="button"
                className={styles.pagerBtn}
                onClick={() => setPage(page - 1)}
              >
                قبلی
              </button>
            ) : null}
            <button type="button" className={`${styles.pagerBtn} ${styles.pagerBtnActive}`}>
              {page}
            </button>
            {pages === page ? null : (
              <button
                type="button"
                className={styles.pagerBtn}
                onClick={() => setPage(page + 1)}
              >
                بعدی
              </button>
            )}
            {pages > 1 ? (
              <span style={{ color: "#64748b", fontSize: 13 }}>
                از {pages} صفحه
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export { MyListOrder };
